import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import { createContext, useContext } from "react";

interface OmniboxResultRowContextValue {
  removePreviousQuery: (result: typeahead.ScoredPreviousQuery) => void;
}

const OmniboxResultRowContext = createContext<
  OmniboxResultRowContextValue | undefined
>(undefined);

export function useOmniboxResultRowContext() {
  const context = useContext(OmniboxResultRowContext);
  if (context === undefined) {
    throw new Error(
      "useOmniboxResultRowContext must be used within a OmniboxResultRowProvider",
    );
  }
  return context;
}

interface OmniboxResultRowProviderProps {
  children: React.ReactNode;
  removePreviousQuery: (result: typeahead.ScoredPreviousQuery) => void;
}

export function OmniboxResultRowProvider({
  children,
  removePreviousQuery,
}: OmniboxResultRowProviderProps) {
  return (
    <OmniboxResultRowContext.Provider value={{ removePreviousQuery }}>
      {children}
    </OmniboxResultRowContext.Provider>
  );
}
